// 引入路由vueRouter
import Vue from 'vue';
import VueRouter from 'vue-router';
// 应用路由VueRouter
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;


VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


const routes = [{
		path: '/',
		name: 'home',
		component: () => import('../page/home/index.vue'),
		meta: {
			title: '首页',
			isLogin: false,
			showLoading:true
		}
	},
	{
		path: '/index',
		name: 'index',
		redirect: '/corpore',
		component: () => import('../page/index.vue'),
		children: [{
				path: '/corpore',
				name: 'corpore',
				component: () => import('../page/corpore/index.vue'),
				meta: {
					title: '竞价处置',
					name: 'corpore',
					isLogin: false,
					keepAlive: true //开启缓存
				}
			},
			{
				path: '/corpore/detail',
				name: 'corporeDetail',
				component: () => import('../page/corporeDetail/index.vue'),
				meta: {
					title: '竞价处置详情',
					name: 'corporeDetail',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/entrustmy/auction/detail',
				name: 'entrustAuctionDetail',
				component: () => import('../page/entrustmy/common/auctiondetail.vue'),
				meta: {
					title: '委托方拍卖详情',
					name: 'entrustAuctionDetail',
					isLogin: true,
					keepAlive: false
				}
			},
			{
				path: '/livestream',
				name: 'livestream',
				component: () => import('../page/livestream/index.vue'),
				meta: {
					title: '直播',
					isLogin: false,
					keepAlive: true //开启缓存
				}
			},
			{
				path: '/pricing',
				name: 'pricing',
				component: () => import('../page/pricing/index.vue'),
				meta: {
					title: '金属行情',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/cooperation',
				name: 'cooperation',
				component: () => import('../page/cooperation/index.vue'),
				meta: {
					title: '合作服务',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/enterprise',
				name: 'enterprise',
				component: () => import('../page/cooperation/enterprise.vue'),
				meta: {
					title: '企业处置',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/biddemand',
				name: 'biddemand',
				component: () => import('../page/cooperation/biddemand.vue'),
				meta: {
					title: '竞买需求',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/release',
				name: 'release',
				component: () => import('../page/cooperation/release.vue'),
				meta: {
					title: '发布需求',
					isLogin: false,
					keepAlive: false //开启缓存
				}
			},
			{
				path: '/about',
				name: 'about',
				component: () => import('../page/about/index.vue'),
				meta: {
					title: '关于我们',
					isLogin: false,
				}
			},
			{
				path: '/help',
				name: 'help',
				component: () => import('../page/help/index.vue'),
				meta: {
					title: '帮助中心',
					isLogin: false,
				}
			},
      // {
      // 	path: '/zhuce',
      // 	name: 'zhuce',
      // 	component: () => import('../page/zhuce/index.vue'),
      // 	meta: {
      // 		title: '注册',
      // 		isLogin: false,
      // 	}
      // },
      // {
      // 	path: '/fuwu',
      // 	name: 'fuwu',
      // 	component: () => import('../page/fuwu/index.vue'),
      // 	meta: {
      // 		title: '服务',
      // 		isLogin: false,
      // 	}
      // },
      // {
      // 	path: '/yinsi',
      // 	name: 'yinsi',
      // 	component: () => import('../page/yinsi/index.vue'),
      // 	meta: {
      // 		title: '隐私',
      // 		isLogin: false,
      // 	}
      // },
			// 回收商个人中心
			{
				path: '/my',
				name: 'my',
				redirect: '/my/account',
				component: () => import('../page/my/my.vue'),
				children: [{
					path: '/my/account',
					name: 'account',
					component: () => import('../page/my/common/account.vue'),
					meta: {
						title: '账户信息',
						name: 'account',
						isLogin: true,
						keepAlive: false //开启缓存
					}
				},{
					path: '/my/auction',
					name: 'auction',
					component: () => import('../page/my/common/auction.vue'),
					meta: {
						title: '我的竞拍',
						name: 'auction',
						isLogin: true,
						keepAlive: false //开启缓存
					}
				},{
					path: '/my/follow',
					name: 'follow',
					component: () => import('../page/my/common/follow.vue'),
					meta: {
						title: '我的关注',
						name: 'auction',
						isLogin: true,
						keepAlive: false //开启缓存
					}
				},{
					path: '/my/footprint',
					name: 'footprint',
					component: () => import('../page/my/common/footprint.vue'),
					meta: {
						title: '我的足迹',
						name: 'auction',
						isLogin: true,
						keepAlive: false //开启缓存
					}
				}]
			},
      {
      	path: '/entrustmy',
      	name: 'entrustmy',
      	redirect: '/entrustmy/account',
      	component: () => import('../page/entrustmy/my.vue'),
      	children: [{
      		path: '/entrustmy/account',
      		name: 'entrustaccount',
      		component: () => import('../page/entrustmy/common/account.vue'),
      		meta: {
      			title: '委托方账户信息',
      			name: 'entrustaccount',
      			isLogin: true,
      			keepAlive: false //开启缓存
      		}
      	},{
      		path: '/entrustmy/entrust',
      		name: 'entrustmyentrust',
      		component: () => import('../page/entrustmy/common/entrust.vue'),
      		meta: {
      			title: '委托方我的委托',
      			name: 'entrustmyentrust',
      			isLogin: true,
      			keepAlive: false //开启缓存
      		}
      	},{
      		path: '/entrustmy/entrustdetail',
      		name: 'entrustmyentrustdetail',
      		component: () => import('../page/entrustmy/common/entrustdetail.vue'),
      		meta: {
      			title: '委托方我的委托',
      			name: 'entrustmyentrustdetail',
      			isLogin: true,
      			keepAlive: false //开启缓存
      		}
      	},{
      		path: '/entrustmy/auction',
      		name: 'entrustmyauction',
      		component: () => import('../page/entrustmy/common/auction.vue'),
      		meta: {
      			title: '委托方我的拍卖',
      			name: 'entrustmyauction',
      			isLogin: true,
      			keepAlive: false //开启缓存
      		}
      	},{
      		path: '/entrustmy/release',
      		name: 'entrustmyrelease',
      		component: () => import('../page/entrustmy/common/release.vue'),
      		meta: {
      			title: '委托方发布委托',
      			name: 'entrustmyrelease',
      			isLogin: true,
      			keepAlive: false //开启缓存
      		}
      	}]
      },
      
      
      // 委托方个人中心
      
      
      
		]
	},


	{
		path: '*',
		name: '404',
		component: () => import('../page/404.vue'),
		meta: {
			title: '404',
			isLogin: false,
		}
	},
	// 回收商登录
	{
		path: '/huiShou',
		name: 'huiShou',
		component: () => import('../page/login/huiShou.vue'),
		meta: {
			title: '回收商登录',
			isLogin: false,
		},
	},
	// 回收商注册
	{
		path: '/huiShouRegister',
		name: 'huiShouRegister',
		component: () => import('../page/register/huiShou.vue'),
		meta: {
			title: '回收商注册',
			isLogin: false,
		},
	},
  // 回收商忘记密码
  {
  	path: '/huiShouPassword',
  	name: 'huiShouPassword',
  	component: () => import('../page/password/huiShou.vue'),
  	meta: {
  		title: '回收商忘记密码',
  		isLogin: false,
  	},
  },
  
  // 委托方登录
  {
  	path: '/weiTuo',
  	name: 'weiTuo',
  	component: () => import('../page/login/weiTuo.vue'),
  	meta: {
  		title: '委托方登录',
  		isLogin: false,
  	},
  },
  
  // 委托方注册
  {
  	path: '/weiTuoRegister',
  	name: 'weiTuoRegister',
  	component: () => import('../page/register/weiTuo.vue'),
  	meta: {
  		title: '委托方注册',
  		isLogin: false,
  	},
  },
  
  
  // 委托方忘记密码
  {
  	path: '/weiTuoPassword',
  	name: 'weiTuoPassword',
  	component: () => import('../page/password/weiTuo.vue'),
  	meta: {
  		title: '委托方忘记密码',
  		isLogin: false,
  	},
  },
]

const router = new VueRouter({
	linkActiveClass: 'selected',
	routes,
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		// 跳转新路由  页面滚动到顶部
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	}
})
export default router
